import camelcaseKeys from 'camelcase-keys'
import { handleResponse, SpecialResponseHandlers } from './handleResponse'

export type CreateJSONHandlerOptions = {
  /** When false, returns parsed JSON without camelCase transformation. Default true. */
  camelCase?: boolean
}

export const createJSONHandler =
  (
    { handleUnauthorized, handleBanned }: SpecialResponseHandlers,
    { camelCase = true }: CreateJSONHandlerOptions = {},
  ) =>
  async (res: Response): Promise<unknown> => {
    await handleResponse(res, {
      handleUnauthorized,
      handleBanned,
    })

    const resData = await res.json().catch(() => ({}))

    if (!camelCase) {
      return resData
    }

    return camelcaseKeys(resData, { deep: true, exclude: [] })
  }
